import { FormControl, FormLabel, Grid, TextField } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import { translations } from 'locales/i18n';
import { useTranslation } from 'react-i18next';

export default function PersonalContacts() {
  const { t } = useTranslation();

  const { errors, touched }: any = useFormikContext();

  return (
    <Grid container>
      <Grid container>
        <FormControl className="listingModal__body__input" required fullWidth>
          <FormLabel className="listingModal__body__input__label">
            {t(translations.pages.listings.create.personalContacts.yourEmail())}
          </FormLabel>
          <Field
            as={TextField}
            name="email"
            variant="outlined"
            fullWidth
            error={touched.email && errors.email}
            helperText={touched.email && errors.email}
            required
          />
        </FormControl>
        <FormControl className="listingModal__body__input" fullWidth>
          <FormLabel className="listingModal__body__input__label">
            {t(translations.pages.listings.create.personalContacts.yourPhoneNumber())}
          </FormLabel>
          <Field
            as={TextField}
            name="phone"
            variant="outlined"
            fullWidth
            error={touched.phone && errors.phone}
            helperText={touched.phone && errors.phone}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
}
